import './radio.css'

import React, { useEffect, useRef } from 'react'

import { i18nText } from '../../../Services';
import { uuid } from 'uuidv4';

export const Radio = props => {
    const { context, element, modelPath } = props;
    const inputModel = context.readModel(modelPath, element.defaultValue || "");

    let inputRef = useRef(null);

    const change = e => {
        inputRef.current.value = e.target.value;
        validator();
    }

    const validator = () => {
        const errors = context.validateElement(inputRef.current, element, inputRef.current.value);
        context.updateModel(modelPath, inputRef.current.value, errors);
    }

    useEffect(() => {
        context.validators.subscribe(validator);
        return () => context.validators.unsubscribe(validator);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context, element, modelPath, inputRef]);

    return (
        <div className={element.inline ? "radio-list-inline" : ""}>
            <input
                type="text"
                ref={inputRef}
                autoComplete="off"
                className="d-none"
                defaultValue={inputModel.value}
                required={element.required}
            />
            {element.options && element.options.map((option) => {
                const id = uuid();
                return (
                    <div key={id} className={"custom-control custom-radio" + (element.inline ? " custom-control-inline" : "")}>
                        <input
                            type="radio"
                            autoComplete="off"
                            checked={String(inputModel.value) === String(option.value)}
                            className={"custom-control-input" + (inputModel.errors.length !== 0 ? " is-invalid" : "") + (element.className ? " " + element.className : "")}
                            disabled={context.isReadOnly}
                            id={id}
                            name={`${element.name}-${modelPath}`}
                            onBlur={validator}
                            onChange={change}
                            value={option.value}
                        />
                        <label className="custom-control-label" htmlFor={id}>{i18nText.getText(option.text)}</label>
                    </div>
                )
            })}
        </div>
    )
}

export default Radio;